import { z } from 'zod/v3';
import { PropertyTypeSchema } from '../generated/enums';

export const AllowedValueSchema = z.object({
  value: z.string(),
  label: z.string(),
  color: z.string().optional(),
  icon: z.string().optional(),
});

export const PropertyDefinitionSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  displayName: z.string(),
  type: PropertyTypeSchema,
  icon: z.string().optional(),
  allowedValues: z.array(AllowedValueSchema).optional(),
  defaultValue: z.string().optional(),
  validation: z.any().optional(),
  required: z.boolean(),
  visible: z.boolean(),
  searchable: z.boolean(),
  description: z.string().optional(),
  order: z.number(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const TopicPropertySchema = z.object({
  id: z.string(),
  topicId: z.string(),
  propertyId: z.string(),
  property: PropertyDefinitionSchema.optional(),
  textValue: z.string().nullable(),
  numberValue: z.number().nullable(),
  dateValue: z.string().datetime().nullable(),
  booleanValue: z.boolean().nullable(),
  arrayValue: z.array(z.string()),
  jsonValue: z.any().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type AllowedValue = z.infer<typeof AllowedValueSchema>;
export type PropertyDefinition = z.infer<typeof PropertyDefinitionSchema>;
export type TopicProperty = z.infer<typeof TopicPropertySchema>;